module.exports = __webpack_public_path__ + "media/images/password_lock-57e6dcb6.svg";